.treatmentHeading {
    color: #3caeb0;
    padding: 80px 0;
}